import React from 'react'
import PropTypes from "prop-types"

export const AnchorSpinner = ({
  loaderSize
}) => {
  return (
    <>
    <span className='loader-bg' />
    <anchor-spinner size={loaderSize} className="loader"/>
    </>
  )
}

AnchorSpinner.defaultProps = {
  loaderSize: "medium",
};

AnchorSpinner.propTypes = {
  loaderSize: PropTypes.string.isRequired,
};